{
  "SEARCH": {
    "TABS": {
      "ALL": "All results",
      "CONTACTS": "Kontakter",
      "CONVERSATIONS": "Samtaler",
      "MESSAGES": "Beskeder",
      "ARTICLES": "Articles"
    },
    "SECTION": {
      "CONTACTS": "Kontakter",
      "CONVERSATIONS": "Samtaler",
      "MESSAGES": "Beskeder",
      "ARTICLES": "Articles"
    },
    "VIEW_MORE": "View more",
    "LOAD_MORE": "Load more",
    "SEARCHING_DATA": "Søger",
    "LOADING_DATA": "Loading",
    "EMPTY_STATE": "No {item} found for query '{query}'",
    "EMPTY_STATE_FULL": "No results found for query '{query}'",
    "PLACEHOLDER_KEYBINDING": "/to focus",
    "INPUT_PLACEHOLDER": "Search messages, contacts or conversations",
    "RECENT_SEARCHES": "Recent searches",
    "CLEAR_ALL": "Clear all",
    "MOST_RECENT": "Most recent",
    "EMPTY_STATE_DEFAULT": "Search by conversation id, email, phone number, messages for better search results.",
    "BOT_LABEL": "Bot",
    "READ_MORE": "Read more",
    "READ_LESS": "Read less",
    "WROTE": "wrote:",
    "FROM": "Fra",
    "EMAIL": "E-mail",
    "EMAIL_SUBJECT": "Emne",
    "PRIVATE": "Private note",
    "TRANSCRIPT": "Transcript",
    "CREATED_AT": "created {time}",
    "UPDATED_AT": "updated {time}",
    "SORT_BY": {
      "RELEVANCE": "Relevance"
    },
    "DATE_RANGE": {
      "LAST_7_DAYS": "Seneste 7 dage",
      "LAST_30_DAYS": "Seneste 30 dage",
      "LAST_60_DAYS": "Seneste 60 dage",
      "LAST_90_DAYS": "Seneste 90 dage",
      "CUSTOM_RANGE": "Custom range:",
      "CREATED_BETWEEN": "Created between",
      "AND": "and",
      "APPLY": "Anvend",
      "BEFORE_DATE": "Before {date}",
      "AFTER_DATE": "After {date}",
      "TIME_RANGE": "Filter by time",
      "CLEAR_FILTER": "Clear filter"
    },
    "FILTERS": {
      "FILTER_MESSAGE": "Filter messages by:",
      "FROM": "Afsender",
      "IN": "Indbakke",
      "AGENTS": "Agenter",
      "CONTACTS": "Kontakter",
      "INBOXES": "Indbakker",
      "NO_AGENTS": "Ingen agenter fundet",
      "NO_CONTACTS": "Start by searching to see results",
      "NO_INBOXES": "No inboxes found"
    }
  }
}
